import { BaseService, QueryParams } from "./BaseService";
import { InvitesInput, InvitesOutput } from "@/interfaces/invites";

export class InvitesService extends BaseService<InvitesInput, InvitesOutput> {
  constructor() {
    super();
    this.path = "invites";
  }

  async acceptInvite(inviteId: string, options?: RequestInit) {
    const url = `${this.path}/${inviteId}/accept`;
    return (await this.request(url, {
      ...options,
      method: "POST",
    })) as InvitesOutput;
  }

  async declineInvite(inviteId: string, options?: RequestInit) {
    const url = `${this.path}/${inviteId}`;
    return (await this.request(url, {
      ...options,
      method: "DELETE",
    })) as InvitesOutput;
  }

  async findByUser(
    userId: string,
    queryParams?: QueryParams,
    options?: RequestInit
  ) {
    const url = `users/${userId}/${this.path}`;
    return (await this.request(url, {
      ...options,
      queryParams,
      method: "GET",
    })) as InvitesOutput[];
  }

  async findByOrganization(
    organizationId: string,
    queryParams?: QueryParams,
    options?: RequestInit
  ) {
    const url = `organizations/${organizationId}/${this.path}`;
    return (await this.request(url, {
      ...options,
      queryParams,
      method: "GET",
    })) as InvitesOutput[];
  }
}
